/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AuthenticatedHomepageRouteRouteImport } from './routes/_authenticated/homepage/route'
import { Route as AuthenticatedProfileRouteRouteImport } from './routes/_authenticated/profile/route'
import { Route as AuthenticatedTicketsRouteRouteImport } from './routes/_authenticated/tickets/route'
import { Route as AuthenticatedUsersRouteRouteImport } from './routes/_authenticated/users/route'

const AuthenticatedHomepageIndexLazyRouteImport = createFileRoute(
  '/_authenticated/homepage/',
)()
const AuthenticatedProfileIndexLazyRouteImport = createFileRoute(
  '/_authenticated/profile/',
)()
const AuthenticatedTicketsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/tickets/',
)()
const AuthenticatedUsersIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/',
)()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/set-password.lazy').then((d) => d.Route))
const AuthenticatedHomepageRouteRoute =
  AuthenticatedHomepageRouteRouteImport.update({
    id: '/homepage',
    path: '/homepage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRouteRoute =
  AuthenticatedProfileRouteRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTicketsRouteRoute =
  AuthenticatedTicketsRouteRouteImport.update({
    id: '/tickets',
    path: '/tickets',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRouteRoute = AuthenticatedUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomepageIndexLazyRoute =
  AuthenticatedHomepageIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedHomepageRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/homepage/index.lazy').then((d) => d.Route),
  )
const AuthenticatedProfileIndexLazyRoute =
  AuthenticatedProfileIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTicketsIndexLazyRoute =
  AuthenticatedTicketsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTicketsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tickets/index.lazy').then((d) => d.Route),
  )
const AuthenticatedUsersIndexLazyRoute =
  AuthenticatedUsersIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUsersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/index.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/homepage': typeof AuthenticatedHomepageRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/tickets': typeof AuthenticatedTicketsRouteRouteWithChildren
  '/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/homepage/': typeof AuthenticatedHomepageIndexLazyRoute
  '/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/tickets/': typeof AuthenticatedTicketsIndexLazyRoute
  '/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/homepage': typeof AuthenticatedHomepageIndexLazyRoute
  '/profile': typeof AuthenticatedProfileIndexLazyRoute
  '/tickets': typeof AuthenticatedTicketsIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_authenticated/homepage': typeof AuthenticatedHomepageRouteRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRouteRouteWithChildren
  '/_authenticated/tickets': typeof AuthenticatedTicketsRouteRouteWithChildren
  '/_authenticated/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/_authenticated/homepage/': typeof AuthenticatedHomepageIndexLazyRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/_authenticated/tickets/': typeof AuthenticatedTicketsIndexLazyRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/set-password'
    | '/homepage'
    | '/profile'
    | '/tickets'
    | '/users'
    | '/homepage/'
    | '/profile/'
    | '/tickets/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/set-password'
    | '/homepage'
    | '/profile'
    | '/tickets'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/set-password'
    | '/_authenticated/homepage'
    | '/_authenticated/profile'
    | '/_authenticated/tickets'
    | '/_authenticated/users'
    | '/_authenticated/homepage/'
    | '/_authenticated/profile/'
    | '/_authenticated/tickets/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/homepage': {
      id: '/_authenticated/homepage'
      path: '/homepage'
      fullPath: '/homepage'
      preLoaderRoute: typeof AuthenticatedHomepageRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tickets': {
      id: '/_authenticated/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AuthenticatedTicketsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/homepage/': {
      id: '/_authenticated/homepage/'
      path: '/'
      fullPath: '/homepage/'
      preLoaderRoute: typeof AuthenticatedHomepageIndexLazyRouteImport
      parentRoute: typeof AuthenticatedHomepageRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexLazyRouteImport
      parentRoute: typeof AuthenticatedProfileRouteRoute
    }
    '/_authenticated/tickets/': {
      id: '/_authenticated/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AuthenticatedTicketsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedTicketsRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexLazyRouteImport
      parentRoute: typeof AuthenticatedUsersRouteRoute
    }
  }
}

interface AuthenticatedHomepageRouteRouteChildren {
  AuthenticatedHomepageIndexLazyRoute: typeof AuthenticatedHomepageIndexLazyRoute
}

const AuthenticatedHomepageRouteRouteChildren: AuthenticatedHomepageRouteRouteChildren =
  {
    AuthenticatedHomepageIndexLazyRoute: AuthenticatedHomepageIndexLazyRoute,
  }

const AuthenticatedHomepageRouteRouteWithChildren =
  AuthenticatedHomepageRouteRoute._addFileChildren(
    AuthenticatedHomepageRouteRouteChildren,
  )

interface AuthenticatedProfileRouteRouteChildren {
  AuthenticatedProfileIndexLazyRoute: typeof AuthenticatedProfileIndexLazyRoute
}

const AuthenticatedProfileRouteRouteChildren: AuthenticatedProfileRouteRouteChildren =
  {
    AuthenticatedProfileIndexLazyRoute: AuthenticatedProfileIndexLazyRoute,
  }

const AuthenticatedProfileRouteRouteWithChildren =
  AuthenticatedProfileRouteRoute._addFileChildren(
    AuthenticatedProfileRouteRouteChildren,
  )

interface AuthenticatedTicketsRouteRouteChildren {
  AuthenticatedTicketsIndexLazyRoute: typeof AuthenticatedTicketsIndexLazyRoute
}

const AuthenticatedTicketsRouteRouteChildren: AuthenticatedTicketsRouteRouteChildren =
  {
    AuthenticatedTicketsIndexLazyRoute: AuthenticatedTicketsIndexLazyRoute,
  }

const AuthenticatedTicketsRouteRouteWithChildren =
  AuthenticatedTicketsRouteRoute._addFileChildren(
    AuthenticatedTicketsRouteRouteChildren,
  )

interface AuthenticatedUsersRouteRouteChildren {
  AuthenticatedUsersIndexLazyRoute: typeof AuthenticatedUsersIndexLazyRoute
}

const AuthenticatedUsersRouteRouteChildren: AuthenticatedUsersRouteRouteChildren =
  {
    AuthenticatedUsersIndexLazyRoute: AuthenticatedUsersIndexLazyRoute,
  }

const AuthenticatedUsersRouteRouteWithChildren =
  AuthenticatedUsersRouteRoute._addFileChildren(
    AuthenticatedUsersRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedHomepageRouteRoute: typeof AuthenticatedHomepageRouteRouteWithChildren
  AuthenticatedProfileRouteRoute: typeof AuthenticatedProfileRouteRouteWithChildren
  AuthenticatedTicketsRouteRoute: typeof AuthenticatedTicketsRouteRouteWithChildren
  AuthenticatedUsersRouteRoute: typeof AuthenticatedUsersRouteRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomepageRouteRoute: AuthenticatedHomepageRouteRouteWithChildren,
  AuthenticatedProfileRouteRoute: AuthenticatedProfileRouteRouteWithChildren,
  AuthenticatedTicketsRouteRoute: AuthenticatedTicketsRouteRouteWithChildren,
  AuthenticatedUsersRouteRoute: AuthenticatedUsersRouteRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
